/**
 * ============================================================================
 * CourtsHeader - PAGE HEADER
 * ============================================================================
 *
 * Title and add court button. Bulk actions removed for production
 * (vendors should manage courts individually).
 *
 * ============================================================================
 */

import React from 'react';
import { Plus } from 'lucide-react';

interface CourtsHeaderProps {
  onAddCourt: () => void;
  canManage?: boolean;
}

/**
 * Courts page header
 */
export function CourtsHeader({ onAddCourt, canManage = true }: CourtsHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      {/* Title Section */}
      <div>
        <h1 className="text-2xl sm:text-3xl font-black text-gray-900 mb-1">Courts & Fields</h1>
        <p className="text-gray-600 text-sm">
          Manage courts and fields for your venue
        </p>
      </div>

      {/* Actions Section */}
      <div className="flex items-center gap-3">
        <button
          onClick={onAddCourt}
          disabled={!canManage}
          title={canManage ? undefined : "You don't have permission to manage courts"}
          className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors text-sm disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-blue-600"
        >
          <Plus className="h-4 w-4 mr-2" />
          Add Court/Field
        </button>
      </div>
    </div>
  );
}
